function getLocationsByCustomerSimple(customerId, oa) {
    return $.ajax({
        url: '/api/customer/GetLocationsSimple?CustomerId=' + customerId,
        async: true,
        dataType: 'json',
        success: function (json) {
            oa(json);
        }
    });
}

function getLocationsByCustomer(customerId, oa) {
    return $.ajax({
        url: '/api/customer/GetLocations?CustomerId=' + customerId,
        async: true,
        dataType: 'json',
        success: function (json) {
            oa(json);
        }
    });
}

function getProjectsByCustomer(customerId, oa) {
    return Q.when($.ajax({
        type: 'POST',
        url: '/Dashboard/GetProjects/' + customerId,
        async: false,
        dataType: 'json',
        success: function(data) {
            oa(data);
            return Q.resolve();
        },
        error: function() {
            return Q.resolve();
        }
    }));
}

function getActiveProjectsByCustomer(customerId, oa) {
    return Q.when($.ajax({
        type: 'GET',
        url: '/api/Project/GetActiveProjects/' + customerId,
        async: false,
        dataType: 'json',
        success: function (data) {
            oa(data);
            return Q.resolve();
        },
        error: function () {
            return Q.resolve();
        }
    }));
}
